import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { useTheme } from '../../theme'

import getStyles from './styles'

const variants = ['primary', 'secondary', 'positive', 'negative', 'dark']

interface ITagProps {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'positive' | 'negative' | 'dark'
  hollow?: boolean
  outline?: boolean
  onClick?: () => void
  style?: Rule
}

export const Tag = ({ children, variant, hollow, outline, onClick, style, ...additional }: ITagProps) => {
  const C = onClick ? 'button' : 'span'
  const clickProps = onClick
    ? {
        onClick,
        role: onClick ? 'button' : undefined,
      }
    : {}
  const styles = getStyles(useTheme())

  return (
    <C
      {...css([
        styles.tag.base,
        onClick && styles.tag.clickable.base,
        onClick && variant && styles.tag.clickable[variant],
        variant && (hollow || outline ? styles.tag.hollow[variant] : styles.tag.filled[variant]),
        hollow || outline ? styles.tag.hollow.base : styles.tag.filled.base,
        style,
      ])}
      {...clickProps}
      {...additional}
    >
      {children}
    </C>
  )
}

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(variants),
  hollow: PropTypes.bool, // deprecated
  outline: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
}

Tag.defaultProps = {
  variant: 'primary',
}

Tag.VARIANTS = variants
